export const DAILY_MISSION_SETTING_LIST = 'DAILY_MISSION_SETTING_LIST';
export const DAILY_MISSION_SETTING_SHOW = 'DAILY_MISSION_SETTING_SHOW';
export const DAILY_MISSION_SETTING_CREATE = 'DAILY_MISSION_SETTING_CREATE';
export const DAILY_MISSION_SETTING_UPDATE = 'DAILY_MISSION_SETTING_UPDATE';
export const DAILY_MISSION_SETTING_STATUS = 'DAILY_MISSION_SETTING_STATUS';
export const DAILY_MISSION_LIST = "DAILY_MISSION_LIST";